import axios, { endpoints } from "src/libs/axios";

export const getPageAction = async (slug: string) => {
  const response = await axios(`${endpoints?.pages?.page}/${slug}`);
  return response?.data;
};
